/*=========================================================================================
  File Name: moduleDiseases.js
  Description: Diseases Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleOpportunitiesState.js'
import mutations from './moduleOpportunitiesMutations.js'
import actions from './moduleOpportunitiesActions.js'
import getters from './moduleOpportunitiesGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
